"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _default = function _default(_ref) {
  var _ref2;

  var actionTypes = _ref.actionTypes,
      property = _ref.property;
  var removeFromSet = actionTypes[property + "/" + _ActionTypes.default.REMOVE_FROM_MAP];
  var addToSet = actionTypes[property + "/" + _ActionTypes.default.ADD_TO_MAP];
  var reorderSet = actionTypes[property + "/" + _ActionTypes.default.REORDER_MAP];
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, removeFromSet, function (state, action) {
    var obj = action.payload[property];
    return state.set(property, state.get(property).delete(obj.id));
  }), (0, _defineProperty2.default)(_ref2, addToSet, function (state, action) {
    var obj = action.payload[property];
    return state.set(property, state.get(property).set(obj.id, obj));
  }), (0, _defineProperty2.default)(_ref2, reorderSet, function (state, action) {
    var newOrder = action.payload[property];
    return state.set(property, newOrder);
  }), _ref2;
};

exports.default = _default;
module.exports = exports.default;